import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TravelPostPreviewLayout from '@cubemeet/module-travel/web/publish/components/TravelPostPreviewLayout';
import { useTravelPostPreviewEditor } from '@cubemeet/module-travel/web/publish/hooks/useTravelPostPreviewEditor';

const TravelPostPreviewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [selectedDayIndex, setSelectedDayIndex] = useState(0);
  const {
    draft,
    timelineDays,
    hiddenEntryIds,
    loading,
    publishing,
    error,
    removeEntry,
    restoreEntry,
    restoreAll,
    addNoteToEntry,
    updateTitle,
    updateSummary,
    updateTags,
    updateSummaryAndTags,
    updateCardGallery,
    publish,
  } = useTravelPostPreviewEditor(id);

  const handlePublish = async () => {
    try {
      const post = await publish();
      if (post?.id) {
        navigate(`/travel-post/${post.id}`, { replace: true });
      }
    } catch (err) {
      // error handled by hook state
    }
  };

  // 上传图片后更新 draft.previewItinerary 中的卡片数据，确保发布时使用最新的 image_gallery
  const handleUpdateCardImage = async (cardId: string, gallery: any[]) => {
    console.log('Card image updated:', cardId, gallery);
    // 更新 draft.previewItinerary 中的卡片数据
    if (updateCardGallery) {
      updateCardGallery(cardId, gallery);
    }
  };

  return (
    <TravelPostPreviewLayout
      loading={loading}
      error={error}
      draft={draft}
      days={draft?.days || []}
      timelineDays={timelineDays || []}
      hiddenEntryIds={hiddenEntryIds}
      selectedDayIndex={selectedDayIndex}
      onSelectDay={setSelectedDayIndex}
      onRemoveEntry={removeEntry}
      onRestoreEntry={restoreEntry}
      onAddNote={addNoteToEntry}
      onUpdateCardImage={handleUpdateCardImage}
      onRestoreAll={restoreAll}
      onPublish={handlePublish}
      publishing={publishing}
      onUpdateTitle={updateTitle}
      onUpdateSummary={updateSummary}
      onUpdateTags={updateTags}
      onUpdateSummaryAndTags={updateSummaryAndTags}
    />
  );
};

export default TravelPostPreviewPage;
